import React, { useEffect, useState } from "react";
import { HeroProductsStatic } from '../../components';
import { Banner, BannerTech } from '../../components';
import { Loader } from '../../components';
import { NumbersWrap } from '../../components';
import { NumbersRowSingle } from '../../components';
import { NumberCell } from '../../components';
import { VideoScrollAlone } from '../../components';
import { GalleryProds } from '../../components';
import { BannerShelfzone } from '../../components';
import { useSelector } from "react-redux";
import { BaseUrl } from "../../config";

const ProductsRetailStoreContainer = (props) => {
  const [imgsGallery, setImgsGallery] = useState([])
  const loader = useSelector((state) => state.loader);

  const imgHero = require('../../assets/hero-solutions/hero-retail.jpg');

  useEffect(() => {
    document.title = "Retail Store Virtualization by Invrsion"
   
    fetch(`${BaseUrl}/page?key=invrsion&slug=retail-store-virtualization`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      setImgsGallery(res.data.sliderSketchfab);
    })
    
    
  }, []);

  const arrayLoad = [
    imgHero
  ]
  
  return (
    <React.Fragment>
      <HeroProductsStatic 
        title="Uncover the full possibilities with Retail Store Virtualization..." 
        img={imgHero}
        subtitle="...maximizing the benefits of your business by perfecting the layout and product placement of your existing or future store. Giving you all the data and tools you need along the way."
      />
          
      <div className="side--quote-wrap extra--margin">
        <h6 className="md--title side--title">What is Retail Store Virtualization?</h6>
        <p className="preset-9 side--text">Perfect the layout and product placement in your current retail space by virtualizing, simulating, and perfecting the shopping experience. Giving you all the insights you need to succeed.</p>
      </div>
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">Data meets details</h6>
        <p className="preset-9 side--text">Track your customers’ every move and extract the realtime data in order to enhance and improve the overall shopping experience for them and you!</p>
      </div>
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">Feel the difference</h6>
        <p className="preset-9 side--text">Following the tightest of industry standards, we use advanced and patented technologies to give your objects the truest-to-life look and feel. The final result is a fully interactive, immersive, and customizable shopping experience, ready to boost your business.</p>
      </div>
      <NumbersWrap>
        <NumbersRowSingle
          extraMargin={true}
        >
          <NumberCell 
            isImage={false} 
            bigNumber="184" 
            size="B" 
            title="Dollar boost" 
            text="to global GDP from the use of VR and AR in the retail and consumer sector by 2030 (PwC)"
          />
          <NumberCell 
            isImage={false} 
            bigNumber="93" 
            size="%" 
            title="Of executives" 
            text="say they or their clients plan to increase their investment in VR and AR in the wake of COVID-19 (IDC)"
          />
        </NumbersRowSingle>
      </NumbersWrap>
      {
        imgsGallery.length > 0 &&
        <GalleryProds imgs={imgsGallery}/>
      }
      {
        !loader.isLoading &&
        <VideoScrollAlone
          idScroll="video-retail"
          video={require('../../assets/video/video-case-retail.mp4')} 
        />
      }
      <BannerShelfzone subtitle="SHELFZONE" text="Build, test, showcase. The one-stop shop to continuously improve your business." route="/shelfzone" copyRoute="Discover Shelfzone"/>
      <Banner 
        text="Intrigued? Let’s have a chat." 
        route="/book-a-demo" 
        copyRoute="Book a demo" 
        isGreenCta={true}
      />
      <Loader arrayLoad={arrayLoad}/>
    </React.Fragment>
  );
};

export default ProductsRetailStoreContainer;
